/* Hope Page containing links to all features
 * Contains all links in large, medium and mobile views */
import React, { useState } from "react";

import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import door from "../../assets/door.png";
// import silverflow from "../../assets/silverflow.jpeg";
// import dim3a from "../../assets/dim3a.png";
import dim3orig from "../../assets/dim3orig.jpg";
import rightdoor from "../../assets/rightdoor.png";
import TopBox from "../../components/TopBox";
import { useRedirect } from "../../hooks/Redirect";
// import { useCrewInfoContext } from "../../contexts/BaseCallContext";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
// import useHostName from "../../hooks/useHostName";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Home.module.css";
import Info1 from "./Info1";
import Info2 from "./Info2";
import Info3 from "./Info3";

const Home = () => {
  useRedirect();
  // eslint-disable-next-line
  const currentUser = useCurrentUser();
  const userGroupNames =
    currentUser?.groups?.map((group) => group?.name?.toLowerCase()) || [];
  const isCastUser = userGroupNames.includes("cast");
  // const crewInfoOne = useCrewInfoContext();
  const [showInfo1, setShowInfo1] = useState(false);
  const [showInfo2, setShowInfo2] = useState(false);
  const [showInfo3, setShowInfo3] = useState(false);
  // const queryString = window.location.search;

  // Television
  const projectCategoryType =
    currentUser?.project_category_type &&
    JSON.parse(currentUser.project_category_type);

  return (
    // <div className={`${styles.Background}`}>
    <div>
      <div className={`${styles.HomeBox}`}
      style={{ backgroundImage: `url(${dim3orig})`,
          // style={{ backgroundImage: `url(${dim3a})`,
          // style={{ backgroundImage: `url(${silverflow})`,
          // style={{ backgroundImage: `url(${city1})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat', }}
          >
        <TopBox
        title="HOME PAGE" />
      {/* info 
       md={{span: 4, offset: 0, order: 1}}
       md={{span: 4, offset: 0, order: 2}}
       md={{span: 4, offset: 0, order: 3}}
      */}
      {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
        <Row className="py-2">
        <Col xs={{span: 6, offset: 0, order: 2}} md={{span: 4, offset: 0, order: 1}}
          className="text-center px-0">
          <Button
            className={` mt-1 mt-md-0 ${btnStyles.Home1} ${btnStyles.Button} px-3 px-md-5`}
            onClick={() => setShowInfo2((showInfo2) => !showInfo2)}
          >
            CREATIVE WORKFLOW
          </Button>
        </Col>
        <Col xs={{span: 6, offset: 3, order: 1}} md={{span: 4, offset: 0, order: 2}}
        className="text-center">
          <Button
            className={` mt-1 mt-md-0 ${btnStyles.Home1} ${btnStyles.Button} px-3 px-md-5`}
            onClick={() => setShowInfo1((showInfo1) => !showInfo1)}
          >
            QUICK START
          </Button>
        </Col>
        <Col xs={{span: 6, offset: 0, order: 12}} md={{span: 4, offset: 0, order: 3}}
        className="text-center px-0">
          <Button
            className={`mt-1 mt-md-0 ${btnStyles.Home1} ${btnStyles.Button} px-1 px-sm-3 px-md-5`}
            onClick={() => setShowInfo3((showInfo3) => !showInfo3)}
          >
            PRODUCTION WORKFLOW
          </Button>
        </Col>
        </Row>
      )}
      <Row className={`${styles.Row1} pt-3 mt-3 mt-md-5`}>
        <Col className="my-3 text-center pr-0 pr-md-5" xs={1} md={1}>
          <Image className={`${styles.FillerImagel}`} src={door} />
        </Col>
        <Col className="my-3" xs={10}>
        {!showInfo1 ? "" : <Info1 />}
        {!showInfo2 ? "" : <Info2 />}
        {!showInfo3 ? "" : <Info3 />}
        <div>
        {/* latest */}
        <Row className="mt-0 mb-3 text-center">
          {currentUser &&
            currentUser?.groups &&
            currentUser?.groups?.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
              <Col xs={{span: 4, offset: 4}} className="px-0">
                <Link to={`/${localStorage.getItem("projectSlug")}/latest`}>
                <OverlayTrigger placement="top"
                  overlay={<Tooltip>All the Latest News and Updates</Tooltip>}>
                    <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
                    <div className={`${styles.BoxBlack}`}>
                  <div className={`py-1  ${styles.LatestBox}`}>
                    <h5 className={`text-center pt-0 `}>Latest Buzz</h5>
                    <div className={`${styles.Inner}`}></div>
                  </div>
                  </div>
                  </div>
                  </div>
                  </OverlayTrigger>
                </Link>
              </Col>
            )}
        </Row>
        {/* Manage Users */}
        {currentUser &&
              currentUser?.groups &&
              currentUser?.groups?.length > 0 &&
              (currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admin") && (
        <Row className="text-center mb-3">
        <Col xs={{span: 8, offset: 2}} className="px-0">
        <Link
          to={`/${localStorage.getItem(
            "projectSlug"
          )}/manage-users`}>
          <OverlayTrigger placement="top"
                  overlay={<Tooltip>Register and Manage Crew and Cast</Tooltip>}>
          <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
          <div className={`${styles.BoxBlack}`}>
          <div className={`py-1  ${styles.AdminBoxNew}`}>
            <h5 className={`text-center pt-0 `}>Manage Users</h5>
            <div className={`${styles.Inner}`}>
            </div>
          </div>
          </div>
          </div>
          </div>
          </OverlayTrigger>
        </Link>
        </Col>
        </Row>
        )}
        {/* char and crew for creative, admin, super */}
        {currentUser &&
              currentUser?.groups &&
              currentUser?.groups?.length > 0 &&
              (currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
        <Row className="text-center mb-3">
        {/* cast */}
        <Col xs={6}>
        <Link
          to={`/${localStorage.getItem(
            "projectSlug"
          )}/characters`}
        >
          <OverlayTrigger placement="top"
                  overlay={<Tooltip>Character Details and Images / Cast Details</Tooltip>}>
                    <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
          <div className={`${styles.BoxBlack}`}>
          <div className={`py-1 ${styles.AdminBoxNew}`}>
            <h5 className={`text-center pt-0 ${styles.Title}`}>
              Characters
            </h5>
            <div className={`${styles.Inner}`}>
            </div>
          </div>
          </div>
          </div>
          </div>
          </OverlayTrigger>
        </Link>
        </Col>
        {/* crew info */}
        <Col xs={6}>
        <Link
          to={`/${localStorage.getItem(
            "projectSlug"
          )}/crewinfo`}>
          <OverlayTrigger placement="top"
                  overlay={<Tooltip>Crew Members' Details by Department</Tooltip>}>
                    <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
          <div className={`${styles.BoxBlack}`}>
          <div className={`py-1 ${styles.AdminBoxNew}`}>
            <h5 className={`text-center pt-0 ${styles.Title}`}>
              Crew Info
            </h5>
            <div className={`${styles.Inner} `}>
            </div>
          </div>
          </div>
          </div>
          </div>
          </OverlayTrigger>
        </Link>
        </Col>
        </Row>
        )}
        {/* char for crew */}
        {currentUser &&
              currentUser?.groups &&
              currentUser?.groups?.length > 0 &&
              (currentUser?.groups[0]?.name === "Crew") && (
        <Row className="text-center mb-3">
        {/* cast */}
        <Col xs={{span: 8, offset: 2}}>
        <Link
          to={`/${localStorage.getItem(
            "projectSlug"
          )}/characters`}>
            <OverlayTrigger placement="top"
                  overlay={<Tooltip>Character Details and Images</Tooltip>}>
                    <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
          <div className={`${styles.BoxBlack}`}>
          <div className={`py-1 ${styles.AdminBoxNew}`}>
            <h5 className={`text-center pt-0 ${styles.Title}`}>
              Characters
            </h5>
            <div className={`${styles.Inner}`}>
            </div>
          </div>
          </div>
          </div>
          </div>
          </OverlayTrigger>
        </Link>
        </Col>
        </Row>
        )}
        {/* Workspace */}
        <Row className="text-center mb-3">
          {currentUser &&
            currentUser?.groups &&
            currentUser?.groups?.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
              <Col xs={6}>
                <Link to={`/${localStorage.getItem("projectSlug")}/scenes`}>
                <OverlayTrigger placement="top"
                  overlay={<Tooltip id={`${styles.TooltipTop}`}>The Primary Creative Workspace by Scene including the Production Tracker</Tooltip>}>
                    <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
                    <div className={`${styles.BoxBlack}`}>
                  <div className={`px-1 py-1  ${styles.PrimaryBoxNew}`}>
                    <h5 className={`text-center pt-1 mb-2 ${styles.Title}`}>
                      Scenes Workspace{" "}
                    </h5>
                    <div className={`${styles.Inner2} `}>
                    </div>
                    </div>
                    </div>
                  </div>
                  </div>
                  </OverlayTrigger>
                </Link>
              </Col>
            )}
            {currentUser &&
            currentUser?.groups &&
            currentUser?.groups?.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
              <Col xs={6}>
                <Link
                  to={
                    projectCategoryType !== "Television"
                      ? `/${localStorage.getItem(
                          "projectSlug"
                        )}/findposts/departments`
                      : `/${localStorage.getItem(
                          "projectSlug"
                        )}/findposts/departments/episodes`
                  }>
                  <OverlayTrigger placement="top"
                  overlay={<Tooltip>Find Scene Workshop Posts Quickly</Tooltip>}>
                  <div className={`${styles.BoxBlack3} p-1`}>
                  <div className={`${styles.BoxBlack2}`}>
                  <div className={`${styles.BoxBlack}`}>
                  <div className={`px-1 py-1  ${styles.PrimaryBoxNew}`}>
                    <h5 className={`text-center pt-1 mb-2 `}>
                      Quick Find Posts
                    </h5>
                    <div className={`${styles.Inner2}`}>
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  </OverlayTrigger>
                </Link>
              </Col>
            )}
        </Row>
        {/* callsheets for cast */}
        {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name === "Cast" && (
        <Row className="text-center">
        <Col className="mt-3" xs={{span: 8, offset: 2}} >             
        <Link
          to={
            projectCategoryType !== "Television"
              ? `/${localStorage.getItem("projectSlug")}/callsheets`
              : `/${localStorage.getItem(
                  "projectSlug"
                )}/callsheets/episodes`
          }>
            <OverlayTrigger placement="top"
          overlay={<Tooltip>Callsheets with Personal Calltimes for each Shoot Day</Tooltip>}>
          <div className={`${styles.BoxBlack}`}>
          <div className={`py-1 ${styles.HomeboxSmErNew}`}>
            <h5 className={`text-center pt-0 ${styles.Title}`}>
              Callsheets
            </h5>
            <div className={`${styles.Inner}`}>
            </div>
          </div>
          </div>
          </OverlayTrigger>
        </Link>
        </Col>
        </Row>
      )}
        {/* all other */}
        <Row className="text-center">
          <Col xs={12}>
            <Row>
              {/* schedule */}
              <Col className="mt-3" xs={6} sm={4} >
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                    <Link
                      to={
                        projectCategoryType !== "Television"
                          ? `/${localStorage.getItem("projectSlug")}/days`
                          : `/${localStorage.getItem(
                              "projectSlug"
                            )}/days/episodes`
                      }>
                      <OverlayTrigger placement="top"
                       overlay={<Tooltip>Shoot Days and Stripboards</Tooltip>}>
                       <div className={`${styles.BoxBlack}`}>
                      <div className={` py-1  ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.Title}`}>
                          Schedule
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                )}
                </Col>
              {/* Callsheets */}
              <Col className="mt-3" xs={6} sm={4}>
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                <Link
                  to={
                    projectCategoryType !== "Television"
                      ? `/${localStorage.getItem("projectSlug")}/callsheets`
                      : `/${localStorage.getItem(
                          "projectSlug"
                        )}/callsheets/episodes`
                  }>
                    <OverlayTrigger placement="top"
                  overlay={<Tooltip>Callsheets with Personal Calltimes for each Shoot Day</Tooltip>}>
                  <div className={`${styles.BoxBlack}`}>
                  <div className={`py-1 ${styles.HomeboxSmErNew}`}>
                    <h5 className={`text-center pt-0 ${styles.Title}`}>
                      Callsheets
                    </h5>
                    <div className={`${styles.InnerD}`}>
                    </div>
                  </div>
                  </div>
                  </OverlayTrigger>
                </Link>
              )}
              </Col>
              {/* Profiles */}
              <Col className="mt-3" xs={6} sm={4}>
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                !isCastUser && (
                    <Link
                      to={`/${localStorage.getItem(
                        "projectSlug"
                      )}/profiles`}>
                        <OverlayTrigger placement="top"
                  overlay={<Tooltip>Crew Profiles with Follow Buttons for Workshop Posts</Tooltip>}>
                      <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1 ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.Title}`}>
                          Profiles
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                )}
                </Col>
                {/* locations */}
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                  <Col className="mt-3" xs={6} sm={4}>
                    <Link
                      to={`/${localStorage.getItem(
                        "projectSlug"
                      )}/locations`}>
                      <OverlayTrigger placement="top"
                       overlay={<Tooltip>Locations' Details and Images</Tooltip>}>
                      <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1  ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.Title}`}>
                          Locations
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                  </Col>
                )}
                {/* depts general */}
                {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                  <Col className="mt-3" xs={6} sm={4}>
                    <Link
                      to={`/${localStorage.getItem(
                        "projectSlug"
                      )}/depts/general`}>
                        <OverlayTrigger placement="top"
                       overlay={<Tooltip>For Department Collaboration and Issues outside of the Scene Workshop </Tooltip>}>
                      <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1  ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.TitleD}`}>
                          Departments
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                  </Col>
                )}
              {/* Moodboards */}
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                  <Col className="mt-3" xs={6} sm={4}>
                    <Link
                      to={`/${localStorage.getItem(
                        "projectSlug"
                      )}/moodshots`}>
                        <OverlayTrigger placement="top"
                       overlay={<Tooltip>Moodboards for Pre-visualisation </Tooltip>}>
                        <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1 ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.TitleD}`}>
                          Moodboards
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                  </Col>
                )}
              {/* cards  */}
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                  <Col className="mt-3" xs={6} sm={4}>
                    <Link
                      to={
                        projectCategoryType !== "Television"
                          ? `/${localStorage.getItem(
                              "projectSlug"
                            )}/indexcards`
                          : `/${localStorage.getItem(
                              "projectSlug"
                            )}/indexcards/episodes`
                      }
                    >
                      <OverlayTrigger placement="top"
                       overlay={<Tooltip>Index Cards for Story and Style Design</Tooltip>}>
                      <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1 ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.Title}`}>
                          Index Cards
                        </h5>
                        <div className={`${styles.InnerD} `}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                  </Col>
              )}
              {/* Index Shots */}
              {currentUser &&
                currentUser?.groups &&
                currentUser?.groups?.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                  <Col className="mt-3" xs={6} sm={4}>
                    <Link
                      to={`/${localStorage.getItem("projectSlug")}/series`}>
                      <OverlayTrigger placement="top"
                       overlay={<Tooltip>Create Images Series to Pre-visualise Sequences </Tooltip>}>
                      <div className={`${styles.BoxBlack}`}>
                      <div className={`py-1  ${styles.HomeboxSmErNew}`}>
                        <h5 className={`text-center pt-0 ${styles.Title}`}>
                          Indexshots
                        </h5>
                        <div className={`${styles.InnerD}`}>
                        </div>
                      </div>
                      </div>
                      </OverlayTrigger>
                    </Link>
                  </Col>
                )}
                {/* second unit */}
                {currentUser &&
                    currentUser?.groups &&
                    currentUser?.groups?.length > 0 &&
                    currentUser?.groups[0]?.name !== "Cast" && (
                          <Col xs={{span: 6, offset: 3}} sm={{span: 4, offset: 0}} className="mt-3">
                            <Link
                              to={`/${localStorage.getItem(
                                "projectSlug"
                              )}/second`}>
                              <OverlayTrigger placement="top"
                               overlay={<Tooltip>The Second Unit Crew Info, Schedule and Callsheets</Tooltip>}>
                                <div className={`${styles.BoxBlack}`}>
                              <div className={`px-3 py-1 ${styles.HomeboxSmErNew}`}>
                                <h5 className={`text-center pt-0 ${styles.Title}`}>
                                  Second Unit
                                </h5>
                                <div className={`${styles.InnerD} `}>
                                </div>
                              </div>
                              </div>
                              </OverlayTrigger>
                            </Link>
                          </Col>
                )}
            </Row>
          </Col>
        </Row>
        </div>
        </Col>
        <Col className={`my-3 text-center pl-0 pl-md-5`} xs={1}>
          <Image className={`${styles.FillerImagel}`} src={rightdoor} />
        </Col>
      </Row>
    </div>
    </div>
  );
};

export default Home;
